// @flow

import type { StoreResourceDef } from 'app/core/types'

export const assetFlags: StoreResourceDef<> = {
  resourceType: 'assetFlags',
  relations: {
    flagInst: {
      type: 'hasOne',
      resourceType: 'flags',
      foreignKey: 'flag',
    },
  },
}
